import { createMachine, assign } from 'xstate';
import { loyaltyClaim } from '../requests/loyalty-claim';

const populateMessage = assign({
  data: (_, payload: any) => {
    const message = payload?.message;
    const error = message?.message;
    const data = payload?.data;

    if (data) {
      logger.debug(`api - loyaltyClaim - FSM data recieved:`, data);
      return data;
    }

    if (error) {
      logger.error(`api - loyaltyClaim - FSM error recieved:`, error);
      return error;
    }

    logger.error(`api - loyaltyClaim - FSM message recieved:`, message);
    return message;
  },
});

const createLoyaltyClaimMachine = ({ token = '', transactionId = '', cart = null } = {}) =>
  createMachine<{
    token: string;
    transactionId: string;
    cart: any;
  }>(
    {
      id: 'loyaltyClaim',
      initial: 'processing',
      context: {
        token,
        transactionId,
        cart,
      },
      states: {
        processing: {
          invoke: {
            src: ({ token, transactionId, cart }) => loyaltyClaim({ token, transactionId, cart }),
            onDone: {
              target: 'success',
              actions: ['populateMessage'],
            },
            onError: {
              target: 'error',
              actions: ['populateMessage'],
            },
          },
        },
        success: {
          on: {
            IDLE: 'processing',
          },
        },
        error: { type: 'final' },
      },
    },
    {
      actions: {
        populateMessage,
      },
    },
  );

export { createLoyaltyClaimMachine };
